import { render } from "./FirstUserPassword.vue?vue&type=template&id=312da55e&scoped=true"
import script from "./FirstUserPassword.vue?vue&type=script&lang=js"
export * from "./FirstUserPassword.vue?vue&type=script&lang=js"

import "@/styles/FirstUserPassword.css?vue&type=style&index=0&id=312da55e&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-312da55e"]])

export default __exports__